import { InfoOutlineIcon } from '@chakra-ui/icons';
import {
    Box,
    Button,
    Checkbox,
    Divider,
    Flex,
    Icon,
    Image,
    Input,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Select,
    Spinner,
    Switch,
    Text,
    Textarea,
    Tooltip,
    useDisclosure,
    useToast,
    useColorModeValue,
    Radio,
    RadioGroup,
    Table,
    Thead,
    Tbody,
    Th,
    Tr,
    Td,
} from '@chakra-ui/react';
import ReplaceDriveModal from 'components/drive/ReplaceDriveModal';
import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import { FaExchangeAlt } from 'react-icons/fa';
import { MdOutlineEdit } from 'react-icons/md';
import { useGetInstantFormsByPageIdQuery } from 'store/campaigns/adsApi';
import { useUpdatePublishAdMutation } from 'store/publishTracking/trackingApi';
import {
    call_to_action_options,
    call_to_action_options_app_promptions,
    call_to_action_options_Awareness_Traffic_Engagement,
    call_to_action_options_for_app_leads_and_sales,
    call_to_action_options_instantForms,
    call_to_action_options_whatsapp
} from 'utils/callToActions';
import { removeEmptyValues } from 'utils/functions';
import imagePlacementConfig from 'utils/imagePlacementConfig.json';
import videoPlacementConfig from 'utils/videoPlacementConfig.json';
import * as Yup from 'yup';
import BuildUrlParamsUpdate from '../BuildUrlParamsUpdate';
import InstagramAccountSelector from '../InstagramAccountSelector';
import UrlParametersUpdate from '../UrlParametersUpdate';
import PublishSizeAdPreviews from './PublishSizeAdPreviews';
import FaceBookPageSelector from '../FaceBookPageSelector';
import PhoneInput from 'react-phone-input-2';
import { useGetAdvertisableAppsQuery } from 'store/campaigns/adsetFormApi';
import MessageTemplateModal from 'components/genericForms/MessageTemplateModal';

const SizePublishAdupdate = ({ trackingData, targeting, onClose, onSaveSuccess }) => {
    const { adsAccount, form, _id, adset, campaign } = trackingData;
    const toast = useToast();
    const background = useColorModeValue('gray.50', 'gray.800');
    const hoverBorderColor = useColorModeValue('gray.300', 'gray.700');
    const borderColor = useColorModeValue('gray.300', 'inherit');
    const backgroundColor = useColorModeValue('#F5F3F9', '#1e1530');
    const { isOpen: isEditMediaOpen, onOpen: OnEditMediaOpen, onClose: OnEditMediaClose } = useDisclosure();
    const { isOpen: isReplaceModalOpen, onOpen: OnReplaceModalOpen, onClose: OnReplaceModalClose } = useDisclosure();
    const { isOpen: isMessageModalOpen, onOpen: onMessageModalOpen, onClose: onMessageModalClose } = useDisclosure();
    const [isEnabled, setIsEnabled] = useState(false);
    const [isUrlModalOpen, setUrlModalOpen] = useState(false);
    const [isUrlParamModalOpen, setUrlParamModalOpen] = useState(false);
    const [selectedMediaUrls, setselectedMediaUrls] = useState([]);
    const [activePlacement, setActivePlacement] = useState(null);

    const [updatePublishAd] = useUpdatePublishAdMutation();

    const pageId = adset?.promoted_object?.page_id;

    const formattedPageIds = Array.isArray(pageId) ? pageId : [pageId];

    const { data: instantForms } = useGetInstantFormsByPageIdQuery(
        { pageIds: formattedPageIds },
        { skip: !formattedPageIds.length || adset?.destination_type !== 'ON_AD' }
    );

    const { data: advertisableApps } = useGetAdvertisableAppsQuery({adsAccountId: adsAccount.adsAccountId}, {skip: !adsAccount.adsAccountId});

    let pageIdToSend = null;

    if (
        ((adset?.destination_type === "PHONE_CALL" ||
        campaign?.objective === "OUTCOME_AWARENESS" ||
        adset?.destination_type === "ON_PAGE" ||
        adset?.destination_type === "WHATSAPP") && pageId)
    ) {
        pageIdToSend = pageId;
    }  

    // Validation Schema
    const validationSchema = Yup.object().shape({
        name: Yup.string().required("Ad Name is required"),
        identity: Yup.object().shape({
            page_id: Yup.string().required("Facebook Page is required"),
            instagram_user_id: Yup.string().notRequired(),
        }),
        adcreative: Yup.object().shape({
            asset_feed_spec: Yup.object().shape({
            destinationType: Yup.string(),
            call_to_action_types: Yup.string().required("Call to action type is required"),
            descriptions: Yup.string().notRequired(),
            deeplink_url: Yup.string().url("Must be a valid URL").notRequired(),
            website_url: Yup.string().when('destinationType', {
                is: (value) => ['WEBSITE', 'OUTCOME_AWARENESS'].includes(value),
                then: () => Yup.string().required("URL is required").url("Must be a valid URL"),
                otherwise: () => Yup.string().notRequired()
            }),
            message: Yup.string().notRequired(),
            name: Yup.string().notRequired(),
            app_product_page_id: Yup.string().notRequired(),
            phoneNumber: Yup.string().
            when('destinationType', {
                is: (value) => value === 'PHONE_CALL',
                then: () => Yup.string()
                    .transform((value) => value.slice(2)) // Remove the first two digits (e.g., country code like "91")
                    .matches(/^[0-9]{10,15}$/, 'Phone number must be at least 10 digits') // Ensure remaining digits are at least 10 digits
                    .required('Phone number is required'), // Ensure phone number is provided
                otherwise: () => Yup.string().notRequired(),
            }),
            contextual_multi_ads: Yup.object().shape({
                enroll_status: Yup.string().notRequired()
            })
            })
        })
    });

    const initialValues = {

        name: "",
        cpa: "",
        identity: {
            page_id: "",
            instagram_user_id: "",
        },
        destination_type: adset?.destination_type,
        adcreative: {
            page_welcome_message: '',
            asset_feed_spec: {
                destinationType: campaign?.objective === "OUTCOME_AWARENESS" ? "OUTCOME_AWARENESS" : adset?.destination_type || "",
                ad_formats: '',
                media: [],
                call_to_action_types: '',
                descriptions: '',
                deeplink_url: '',
                phoneNumber: '',
                website_url: '',
                message: '',
                description: '',
                caption: '',    
                name: '',
                app_product_page_id: '',
                contextual_multi_ads: {
                    enroll_status: ''
                },
                url_tags: '',
                pac_relaxation_enroll_status: 'OPT_IN', 
            },
        }
    };
      

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit: (values, { setSubmitting }) => {

            // Step 1: Create a hash -> { mediaType, placement } map
            const hashMap = {};
            selectedMediaUrls?.forEach(item => {
                hashMap[item.hash] = {
                    mediaType: item.mediaType,
                    placement: item.placement
                };
            });

            // Step 2: Deduplicate mediaData based on hash
            const seenHashes = new Set();
            const hashDuplicates = new Map();

            // First pass: gather duplicates by hash
            selectedMediaUrls?.forEach(item => {
                if (seenHashes.has(item.hash)) {
                    if (!hashDuplicates.has(item.hash)) {
                        hashDuplicates.set(item.hash, []);
                    }
                    hashDuplicates.get(item.hash).push(item.placement);
                } else {
                    seenHashes.add(item.hash);
                }
            });

            // Reset seenHashes to reuse it
            seenHashes.clear();

            // Second pass: build mediaData with tags
            const mediaData = selectedMediaUrls?.filter(item => {
                if (seenHashes.has(item.hash)) return false;
                seenHashes.add(item.hash);
                return true;
            })
                .map(item => {
                    const duplicatePlacements = hashDuplicates.get(item.hash);
                    const tag = duplicatePlacements?.length
                        ? { duplicatePlacements }
                        : undefined;

                    return {
                        [item.mediaType === 'image' ? 'hash' : 'video_id']: item.hash,
                        thumbnail_url: item.url,
                        [item.mediaType === 'image' ? 'creative_hash' : 'hash']: item.mediaHash,
                        mediaType: item.mediaType,
                        adlabels: [{ name: item.placement }],
                        ...(tag && { tag })
                    };
                });

            // Remove 'tag' before assigning
            const cleanedMediaData = mediaData?.map(({ tag, mediaType, ...rest }) => rest);

            // Step 3: Build asset_customization_rules using hashMap
            const asset_customization_rules = [];

            mediaData?.forEach(media => {
                const meta = hashMap[media.mediaType === 'image' ? media.hash : media.video_id];
                if (!meta) return; // safety check

                const { mediaType } = meta;
                const isDuplicate = media.tag?.duplicatePlacements?.length > 0;

                (media?.adlabels || []).forEach(label => {
                    const placement = label.name;
                    if (!placement) return;

                    asset_customization_rules?.push({
                        [mediaType === 'image' ? 'image_label' : 'video_label']: { name: placement },
                        customization_spec: isDuplicate
                            ? {}
                            : (mediaType === 'image' ? imagePlacementConfig : videoPlacementConfig)[placement] || {}
                    });
                });
            });

            const titles = values.adcreative.asset_feed_spec.name
                ? [{ text: values.adcreative.asset_feed_spec.name }]
                : undefined;

            const bodies = values.adcreative.asset_feed_spec.message
                ? [{ text: values.adcreative.asset_feed_spec.message }]
                : undefined;

            const descriptions = values.adcreative.asset_feed_spec.description
                ? [{ text: values.adcreative.asset_feed_spec.description }]
                : undefined;

            const call_to_action_types = [values.adcreative.asset_feed_spec.call_to_action_types];

            const call_to_actions = [
                ...(adset?.destination_type === 'PHONE_CALL' ? [{
                  type: values.adcreative.asset_feed_spec.call_to_action_types,
                  value: {
                    link: `tel:+${values.adcreative.asset_feed_spec.phoneNumber?.replace(/^(\+)?/, '')}`
                  }
                }] : []),
              
                ...(adset?.destination_type === 'ON_AD' ? [{
                  type: values.adcreative.asset_feed_spec.call_to_action_types,
                  value: {
                    lead_gen_form_id: values.adcreative.asset_feed_spec.website_url
                  }
                }] : [])
            ];

            const link_urls = [
                {
                    website_url: adset?.destination_type === 'PHONE_CALL' ? `https://facebook.com/${values.identity.page_id}/`  : adset?.destination_type === 'ON_AD' ? "http://fb.me/" : values.adcreative.asset_feed_spec.website_url,
                    deeplink_url: values.adcreative.asset_feed_spec.deeplink_url,
                    ...(!['CALL_NOW','LIKE_PAGE'].includes(values.adcreative.asset_feed_spec.call_to_action_types) && {display_url: values.adcreative.caption})
                }
            ];

            const app_product_page_id = values.adcreative.asset_feed_spec.app_product_page_id;

            let creativePayload = {};

            creativePayload = values?.adcreative.asset_feed_spec?.ad_formats === 'SINGLE_VIDEO' ?
                {
                    adcreative: {
                        asset_feed_spec: {
                            ad_formats: [
                                "SINGLE_VIDEO"
                            ],
                            videos: cleanedMediaData,
                            asset_customization_rules: asset_customization_rules,
                            call_to_action_types,
                            call_to_actions,
                            link_urls,
                            app_product_page_id,
                            optimization_type: "PLACEMENT",
                            ...(titles && { titles }),
                            ...(bodies && { bodies }),
                            ...(descriptions && { descriptions }),
                        },
                        ...((['WHATSAPP'].includes(adset?.destination_type)) && { page_welcome_message: values?.adcreative?.page_welcome_message }),
                        contextual_multi_ads: {
                            enroll_status: values.adcreative.contextual_multi_ads.enroll_status
                        },
                        ...(["OUTCOME_AWARENESS", "OUTCOME_TRAFFIC", "OUTCOME_ENGAGEMENT"].includes(campaign?.objective) && {
                            degrees_of_freedom_spec: {
                                creative_features_spec: {
                                  standard_enhancements: { enroll_status: "OPT_OUT" },
                                  ...((values.adcreative.asset_feed_spec.call_to_action_types !== 'LIKE_PAGE') && {
                                    pac_relaxation: { enroll_status: values.adcreative.pac_relaxation_enroll_status },
                                })
                                },
                              },
                        }),
                        ...((campaign?.objective === "OUTCOME_AWARENESS" || adset?.destination_type === "ON_VIDEO") && {
                            template_url_spec: { config: { app_id: values.adcreative.app_id } },
                        }),
                        ...(values.adcreative?.url_tags?.trim() && { url_tags: values.adcreative.url_tags }),
                    }
                }
                :
                {
                    adcreative: {
                        asset_feed_spec: {
                            ad_formats: [
                                "SINGLE_IMAGE"
                            ],
                            images: cleanedMediaData,
                            asset_customization_rules: asset_customization_rules,
                            call_to_action_types,
                            call_to_actions,
                            link_urls,
                            app_product_page_id,
                            optimization_type: "PLACEMENT",
                            ...(titles && { titles }),
                            ...(bodies && { bodies }),
                            ...(descriptions && { descriptions }),
                        },
                        contextual_multi_ads: {
                            enroll_status: values.adcreative.contextual_multi_ads.enroll_status
                        },
                        ...((['WHATSAPP'].includes(adset?.destination_type)) && { page_welcome_message: values?.adcreative?.page_welcome_message }),
                        ...(
                            ["OUTCOME_AWARENESS", "OUTCOME_TRAFFIC", "OUTCOME_ENGAGEMENT"].includes(campaign?.objective) &&
                            values.adcreative.asset_feed_spec.call_to_action_types !== 'LIKE_PAGE'
                              ? {
                                  degrees_of_freedom_spec: {
                                    creative_features_spec: {
                                      pac_relaxation: {
                                        enroll_status: values.adcreative.pac_relaxation_enroll_status,
                                      }
                                    }
                                  }
                                }
                              : {}
                        ),
                        ...((campaign?.objective === "OUTCOME_AWARENESS" || adset?.destination_type === "ON_VIDEO") && {
                            template_url_spec: { config: { app_id: values.adcreative.app_id } },
                        }),
                        ...(values.adcreative?.url_tags?.trim() && { url_tags: values.adcreative.url_tags }),
                    }
                }

            const initialPayload = {
                ...creativePayload,
                name: values.name,
                cpa: values.cpa,
                identity: {
                    page_id: values.identity.page_id,
                    ...(values?.identity?.instagram_user_id.trim() && {
                        instagram_user_id: values?.identity?.instagram_user_id,
                    }),
                },

            };

            const filteredPayload = removeEmptyValues(initialPayload);

            updatePublishAd({ trackingId: _id, payload: filteredPayload })
                .unwrap()
                .then(response => {
                    onSaveSuccess();
                    toast({
                        position: "top-right",
                        title: "Ad updated",
                        status: "success",
                        duration: 4000,
                        isClosable: true,
                    });
                })
                .catch(error => {
                    toast({
                        position: "top-right",
                        title: "Error updating ad",
                        description: error?.data?.message,
                        status: "error",
                        duration: 4000,
                        isClosable: true,
                    });
                })
                .finally(() => {
                    setSubmitting(false);
                    onClose();
                });
        },
    });

    useEffect(() => {
        if (form) {
            const spec = form.adcreative?.asset_feed_spec || {};

            formik.setValues({
                name: form.name || '',
                identity: {
                    page_id: form.identity?.page_id || "",
                    instagram_user_id: form.identity?.instagram_user_id || "",
                },
                adcreative: {
                    url_tags: form?.adcreative?.url_tags || '',
                    pac_relaxation_enroll_status: form?.adcreative?.degrees_of_freedom_spec?.creative_features_spec?.pac_relaxation?.enroll_status || 'OPT_IN', 
                    caption: form?.adcreative?.caption || '',
                    app_id: form?.adcreative?.template_url_spec?.config?.app_id || '', 
                    page_welcome_message: form?.adcreative?.page_welcome_message,
                    asset_feed_spec: {
                        destinationType: campaign?.objective === "OUTCOME_AWARENESS" ? "OUTCOME_AWARENESS" : adset?.destination_type || "",
                        fileName: spec.fileName || '',
                        ad_formats: Array.isArray(spec.ad_formats) ? spec.ad_formats[0] || '' : '',
                        media:
                            Array.isArray(spec.ad_formats) && spec.ad_formats[0] === 'SINGLE_VIDEO'
                                ? spec.videos || []
                                : spec.images || [],
                        call_to_action_types: Array.isArray(spec.call_to_action_types) ? spec.call_to_action_types[0] || '' : '',
                        description: Array.isArray(spec.descriptions) ? spec.descriptions[0]?.text || '' : '',
                        deeplink_url: Array.isArray(spec.link_urls) ? spec.link_urls[0]?.deeplink_url || '' : '',
                        website_url: Array.isArray(spec.link_urls) ? spec.link_urls[0]?.website_url || '' : '',
                        phoneNumber:
                            spec?.call_to_actions &&
                            spec?.call_to_actions[0]?.value?.link?.includes('tel:+')
                            ?  spec?.call_to_actions[0]?.value?.link.replace('tel:+', '')
                            : '',
                        message: Array.isArray(spec.bodies) ? spec.bodies[0]?.text || '' : '',
                        name: Array.isArray(spec.titles) ? spec.titles[0]?.text || '' : '',
                        app_product_page_id: spec.app_product_page_id || '',
                    },
                    contextual_multi_ads: {
                        enroll_status: form.adcreative?.contextual_multi_ads?.enroll_status || '',
                    },
                }
            });
        }
    }, [form]);

    useEffect(() => {
        const assetFeed = form.adcreative?.asset_feed_spec;
        if (!assetFeed) return;

        const isVideo = assetFeed?.ad_formats?.[0] === 'SINGLE_VIDEO';
        const media = isVideo ? assetFeed.videos || [] : assetFeed.images || [];
        const customizationRules = assetFeed.asset_customization_rules || [];

        // Step 1: Build a map of media data by label
        const mediaMap = {};
        media.forEach((file) => {
            const label = file?.adlabels?.[0]?.name;
            if (label) {
                mediaMap[label] = {
                    placement: label,
                    url: file?.thumbnail_url,
                    mediaType: isVideo ? 'video' : 'image',
                    hash: isVideo ? file?.video_id : file?.hash,
                };
            }
        });

        // Step 2: Find fallback label from customization_rules with empty customization_spec
        const fallbackLabel = customizationRules.find(rule => {
            const spec = rule?.customization_spec;

            // Case 1: customization_spec is missing
            if (!spec) return true;

            const keys = Object.keys(spec).sort();

            // Case 2: customization_spec is empty
            if (keys.length === 0) return true;

            // Case 3: customization_spec has only age_min and age_max
            return keys.length === 2 && keys.includes('age_min') && keys.includes('age_max');
        })?.[isVideo ? 'video_label' : 'image_label']?.name;

        const fallbackMedia = mediaMap[fallbackLabel];

        // Step 3: Ensure all 3 placements
        const requiredPlacements = ['square', 'vertical', 'horizontal'];
        const finalMedia = requiredPlacements.map((label) => {
            if (mediaMap[label]) {
                return mediaMap[label];
            } else if (fallbackMedia) {
                return {
                    ...fallbackMedia,
                    placement: label,
                };
            } else {
                return null;
            }
        }).filter(Boolean); // Remove nulls

        setselectedMediaUrls(finalMedia);
    }, [form.adcreative]);

    useEffect(() => {
        if (selectedMediaUrls.length > 0) {
            formik.setFieldValue('mediaUrls', selectedMediaUrls);
        }
    }, [selectedMediaUrls])

    const handleReplaceImage = (placement, type) => {
        setActivePlacement(placement);
        OnReplaceModalOpen();
    };

    const handleImageSelectedFromReplaceDrive = (file) => {
        if (file && file.length > 0) {

            const newImageUrl = file[0];

            setselectedMediaUrls((prev) =>
                prev.map((item) =>
                    item.placement === activePlacement
                        ? {
                            ...item,
                            url: newImageUrl?.url ? newImageUrl?.url : newImageUrl?.picture,
                            hash: newImageUrl?.creativeId,
                            mediaHash: newImageUrl?.hash,
                            source: newImageUrl?.source,
                        }
                        : item
                )
            );
        }
        setActivePlacement(null);
        OnReplaceModalClose();
    };

    const handleUrlChange = (constructedUrl) => {
        formik.setFieldValue('adcreative.link', constructedUrl);
    };

    const handleUrlParamChange = (constructedUrl) => {
        formik.setFieldValue('adcreative.url_tags', constructedUrl);
    };

    const filteredInstantForms = instantForms?.length > 0 && instantForms
        .map((formResponse) => formResponse?.data?.data) // Get the 'data' array from each formResponse
        .flat() // Flatten the array to get all forms in one array
        .filter((form) => form?.page_id === pageId);

    if (!trackingData || !formik.values) {
        return <Spinner mt={'20px'} />;
    }

    return (
        <form onSubmit={formik.handleSubmit}>
            <Flex gap={4}>
                <Flex direction={'column'} flex={0.4}>
                    <Flex direction={'column'} gap={4} borderRadius="md" bg={background} p={4} mb={4}>
                        <Flex direction="column" gap={1}>
                            <Text fontWeight="bold">Ad Name</Text>
                            <Input
                                name="name"
                                placeholder="Enter ad name"
                                size='sm'
                                borderRadius="md"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.name}
                            />
                            {formik.touched.name && formik.errors.name && (
                                <Text fontSize={"12px"} color="red.500">{formik.errors.name}</Text>
                            )}
                        </Flex>

                        <Flex direction="column" gap={1}>
                            <Text fontWeight="bold">Facebook Page</Text>
                             <FaceBookPageSelector
                                adsAccount={{
                                    account_id: adsAccount.adsAccountId,
                                    name: adsAccount.adsAccountName
                                }}
                                pageIdToSend={pageIdToSend ? pageIdToSend : ''}
                                selectedPageId={formik?.values?.identity?.page_id}
                                onSelectedPage={(pageId) => {
                                    formik.setFieldValue('identity.page_id', pageId);

                                    // Reset the Instagram actor ID to an empty string
                                    formik.setFieldValue('identity.instagram_user_id', '');
                                }}
                            />
                            {formik.errors.identity?.page_id && (
                                <Text fontSize={"12px"} color="red.500">{formik.errors.identity?.page_id}</Text>
                            )}
                        </Flex>

                        <Flex direction="column" gap={1}>
                            <Text fontWeight="bold">Instagram accounts</Text>
                            <InstagramAccountSelector
                                adsAccount={adsAccount}
                                selectedInstPageId={formik?.values?.identity?.instagram_user_id}
                                onSelectedPage={(pageId) => {
                                    formik.setFieldValue('identity.instagram_user_id', pageId);
                                }}
                                pageID={formik?.values?.identity?.page_id}
                            />
                        </Flex>
                    </Flex>
                    <Flex direction={'column'} gap={4} borderRadius="md" bg={background} p={4} mb={4}>
                        {/* Multi-advertiser ads Section */}
                        <Flex direction="column" mb={4} borderRadius="md" gap={2}>
                            <Checkbox
                                onChange={(e) => {
                                    formik.setFieldValue("adcreative.contextual_multi_ads.enroll_status", e.target.checked ? 'OPT_IN' : 'OPT_OUT');
                                }}
                                colorScheme="brand"
                                isChecked={formik?.values.adcreative?.contextual_multi_ads?.enroll_status === 'OPT_IN'}
                            >
                                <Flex align={'center'}>
                                    <Text fontWeight="bold" fontSize={'14px'}>Multi-advertiser ads &nbsp;</Text>
                                    <Tooltip
                                        borderRadius={5}
                                        label={
                                            <Box fontSize="sm" p="5px">
                                                <Text>Your ads can appear alongside other ads in the same ad unit to help people discover products and services from businesses that are personalized to them. Your ad creative may be resized or cropped to fit the ad unit.</Text>
                                            </Box>
                                        }
                                        fontSize="md"
                                    >
                                        <InfoOutlineIcon pointerEvents="all" />
                                    </Tooltip>
                                </Flex>
                            </Checkbox>
                        </Flex>

                        <Box>
                            <Text fontWeight="bold" mb={2}>Ad Creative</Text>
                            <Flex direction="row" gap={2} alignItems={'center'}>
                                {selectedMediaUrls && selectedMediaUrls[0]?.url ? (
                                    <Image
                                        src={(selectedMediaUrls[0]?.url)}
                                        alt={"adcreative-img"}
                                        objectFit="cover"
                                        width="80px"
                                        height="80px"
                                        borderRadius="3px"
                                    />
                                ) : null}
                                {selectedMediaUrls && selectedMediaUrls[0]?.url ?
                                    <Flex>
                                        <Tooltip label="Edit Media" fontSize="xs">
                                            <Flex
                                                p={2}
                                                border="1px solid"
                                                borderColor={borderColor}
                                                borderRadius="md"
                                                alignItems={'center'}
                                                _hover={{ bg: hoverBorderColor }}
                                            >
                                                <Icon
                                                    as={MdOutlineEdit}
                                                    cursor="pointer"
                                                    fontSize="18px"
                                                    onClick={OnEditMediaOpen}
                                                />
                                            </Flex>
                                        </Tooltip>
                                    </Flex>
                                    : null
                                }
                            </Flex>

                            {["OUTCOME_AWARENESS", "OUTCOME_TRAFFIC", "OUTCOME_ENGAGEMENT", "OUTCOME_SALES", "OUTCOME_LEADS"].includes(campaign?.objective) &&  !['WEBSITE_AND_PHONE_CALL', 'WEBSITE_AND_LEAD_FORM'].includes(adset?.destination_type) ?    
                                    <Flex direction={'column'} gap={2} mt={2}>
                                        <Flex alignItems="center">
                                            <Text fontWeight="bold" mr={2}>Flexible media</Text>
                                            <Tooltip
                                                borderRadius={5}
                                                label={
                                                    <Flex direction={'column'} fontSize="12px" p="5px" gap={2}>
                                                        <Text fontWeight={'bold'}>Flexible media</Text>
                                                        <Text>Show media that you chose for a specific aspect ratio across all placements when it's likely to improve performance. You can turn off flexible media at any time in ad creative.</Text>
                                                        <Text>To preview flexible media, select a specific placement group at the top of Ad preview.</Text>
                                                    </Flex>
                                                }
                                                fontSize="md"
                                            >
                                                <InfoOutlineIcon pointerEvents="all" />
                                            </Tooltip>
                                        </Flex>
                                        <Flex alignItems={'center'} gap={2}>
                                            <Switch colorScheme='brand' size={'sm'} isChecked={formik.values.adcreative.pac_relaxation_enroll_status === 'OPT_IN'} onChange={(e) => formik.setFieldValue('adcreative.pac_relaxation_enroll_status', e.target.checked ? 'OPT_IN' : 'OPT_OUT')} />
                                            <Text fontSize="12px">We'll deliver your media selections across your placements when it's likely to improve performance.</Text>
                                        </Flex>
                                    </Flex>
                            :null}
                        </Box>

                        <Flex direction="column" gap={1}>
                            <Text fontWeight="bold">Primary text</Text>
                            <Textarea
                                name="adcreative.asset_feed_spec.message"
                                placeholder="Enter message"
                                size='sm'
                                borderRadius="md"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik?.values?.adcreative?.asset_feed_spec?.message}
                            />
                        </Flex>

                        <Flex direction="column" gap={1}>
                            <Text fontWeight="bold">Headline</Text>
                            <Input
                                name="adcreative.asset_feed_spec.name"
                                placeholder="Write a short headline"
                                size='sm'
                                borderRadius="md"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik?.values?.adcreative?.asset_feed_spec?.name}
                            />
                        </Flex>

                        {['APP','ON_PAGE'].includes(adset?.destination_type) ? null :
                            <Flex direction="column" gap={1}>
                                <Text fontWeight="bold">Description</Text>
                                <Textarea
                                    name="adcreative.asset_feed_spec.description"
                                    placeholder="Enter description"
                                    size='sm'
                                    borderRadius="md"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.adcreative.asset_feed_spec.description}
                                />
                            </Flex>
                        }

                        {adset?.destination_type === 'ON_PAGE' ? null :
                            <Flex direction="column" gap={1}>
                                <Text fontWeight="bold">Call to action</Text>

                                {adset?.destination_type === 'PHONE_CALL' ? (
                                    <Select
                                        name="adcreative.asset_feed_spec.call_to_action_types.type"
                                        size="sm"
                                        borderRadius="md"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik?.values?.adcreative?.asset_feed_spec?.call_to_action_types}
                                        isDisabled
                                    >
                                        <option value="CALL_NOW">Call Now</option>
                                    </Select>
                                ) : adset?.destination_type === 'ON_AD' ? (
                                    <Select
                                        name="adcreative.asset_feed_spec.call_to_action_types.type"
                                        size="sm"
                                        borderRadius="md"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik?.values?.adcreative?.asset_feed_spec?.call_to_action_types}
                                    >
                                        {call_to_action_options_instantForms?.map((option) => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </Select>
                                 ) : adset?.destination_type === 'WHATSAPP' ? (
                                        <Select
                                            name="adcreative.asset_feed_spec.call_to_action_types.type"
                                            size="sm"
                                            borderRadius="md"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik?.values?.adcreative?.asset_feed_spec?.call_to_action_types}
                                            isDisabled={campaign?.objective === 'OUTCOME_LEADS'}
                                        >
                                            {call_to_action_options_whatsapp?.map((option) => (
                                                <option key={option.value} value={option.value}>
                                                    {option.label}
                                                </option>
                                            ))}
                                        </Select>
                                ) : adset?.destination_type === 'APP' && campaign?.objective === "OUTCOME_APP_PROMOTION" ? (
                                    <Select
                                        name="adcreative.asset_feed_spec.call_to_action_types.type"
                                        size="sm"
                                        borderRadius="md"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik?.values?.adcreative?.asset_feed_spec?.call_to_action_types}
                                    >
                                        {call_to_action_options_app_promptions.map(option => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </Select>
                                ) :  adset?.destination_type === 'APP' && ["OUTCOME_SALES", "OUTCOME_LEADS"].includes(campaign?.objective) ? (
                                    <Select
                                        name="adcreative.asset_feed_spec.call_to_action_types.type"
                                        size="sm"
                                        borderRadius="md"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik?.values?.adcreative?.asset_feed_spec?.call_to_action_types}
                                    >
                                        {call_to_action_options_for_app_leads_and_sales.map(option => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </Select>
                                ) : campaign?.objective === "OUTCOME_AWARENESS" || (["OUTCOME_ENGAGEMENT","OUTCOME_TRAFFIC"].includes(campaign?.objective) && adset?.destination_type === 'WEBSITE') || adset?.destination_type === 'ON_VIDEO'? (
                                    <Select
                                        name="adcreative.asset_feed_spec.call_to_action_types.type"
                                        size="sm"
                                        borderRadius="md"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik?.values?.adcreative?.asset_feed_spec?.call_to_action_types}
                                    >
                                        {call_to_action_options_Awareness_Traffic_Engagement?.map((option) => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </Select>
                                ) : 
                                    <Select
                                        name="adcreative.asset_feed_spec.call_to_action_types.type"
                                        size="sm"
                                        borderRadius="md"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik?.values?.adcreative?.asset_feed_spec?.call_to_action_types}
                                    >
                                        {call_to_action_options.map(option => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </Select>
                                }
                            </Flex>
                        }

                        {adset?.destination_type === 'PHONE_CALL' ? (
                            <Flex direction="column" gap={1}>
                                <Text fontWeight="bold">Phone Number</Text>
                                <PhoneInput
                                    name="adcreative.asset_feed_spec.phoneNumber"
                                    value={formik.values.adcreative?.asset_feed_spec?.phoneNumber}
                                    onChange={(value) => formik.setFieldValue('adcreative.asset_feed_spec.phoneNumber', value)}
                                    country={'in'}
                                />
                                {formik.errors.adcreative?.asset_feed_spec?.phoneNumber && (
                                    <Text fontSize={"12px"} color="red.500">{formik.errors.adcreative?.asset_feed_spec?.phoneNumber}</Text>
                                )}
                            </Flex>
                        ) : ['WEBSITE', 'ON_VIDEO'].includes(adset?.destination_type) || campaign?.objective === "OUTCOME_AWARENESS"  ? (
                            <Flex direction="column" gap={1}>
                                <Text fontWeight="bold">Website URL</Text>
                                <Input
                                    name="adcreative.asset_feed_spec.website_url"
                                    placeholder="Enter link URL"
                                    size='sm'
                                    borderRadius="md"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.adcreative.asset_feed_spec.website_url}
                                />
                                <Flex mt={2}>
                                    <Button onClick={() => {
                                        setUrlModalOpen(true)
                                    }}
                                        variant="link"
                                        color='brand'>
                                        <Text fontSize={'12px'} >{'Build a URL parameter'}</Text>
                                    </Button>
                                </Flex>
                                {formik.touched?.adcreative?.asset_feed_spec?.website_url && formik.errors?.adcreative?.asset_feed_spec?.website_url && (
                                    <Text fontSize={"12px"} color="red.500">{formik.errors.adcreative.asset_feed_spec.website_url}</Text>
                                )}
                            </Flex>
                        ) : adset?.destination_type === 'ON_AD' ? (
                            <>
                                <Flex alignItems="center" gap={2} mt={2}>
                                    <Text fontWeight="bold">Instant form</Text>
                                    <Tooltip
                                        borderRadius={5}
                                        label={
                                            <Box fontSize="sm" p="5px">
                                                <Text>Make connections with people by letting them send contact information and other details to you through a form.</Text>
                                            </Box>
                                        }
                                        fontSize="md"
                                    >
                                        <InfoOutlineIcon pointerEvents="all" />
                                    </Tooltip>
                                </Flex>

                                {/* Table Layout */}
                                {filteredInstantForms?.length > 0 ? (
                                    <RadioGroup onChange={(value) => formik.setFieldValue('adcreative.asset_feed_spec.website_url', value)} value={formik.values.adcreative.asset_feed_spec.website_url} colorScheme="brand">
                                        <Table variant="simple">
                                            <Thead>
                                                <Tr>
                                                    <Th textTransform={'none'} color={'none'} fontSize="14px">Form title</Th>
                                                    <Th textTransform={'none'} color={'none'} fontSize="14px">Creation date</Th>
                                                </Tr>
                                            </Thead>
                                            <Tbody>
                                                {filteredInstantForms?.map((form) => (
                                                    <Tr key={form?.id} _hover={{ backgroundColor: '#F9F9F9' }} >
                                                        <Td>
                                                            <Flex alignItems="center" gap={2}>
                                                                <Radio value={form?.id} />
                                                                <Text color={form.status === 'DRAFT' ? "gray.500" : "black"} fontSize={'12px'}>
                                                                    {form?.name}
                                                                </Text>
                                                            </Flex>
                                                        </Td>
                                                        <Td>
                                                            <Text fontSize={'12px'}>
                                                                {new Date(form?.created_time).getFullYear()}-
                                                                {String(new Date(form?.created_time).getMonth() + 1).padStart(2, '0')}-
                                                                {String(new Date(form?.created_time).getDate()).padStart(2, '0')}
                                                            </Text>
                                                        </Td>
                                                    </Tr>
                                                ))}
                                            </Tbody>
                                        </Table>
                                    </RadioGroup>
                                ) : (
                                    <Text fontSize="14px" color="gray.500">No form data available</Text>
                                )}
                            </>
                        ) : adset?.destination_type === 'APP' && campaign?.objective === 'OUTCOME_APP_PROMOTION' ? (
                            <>
                                <Flex direction="column" gap={1}>
                                    <Flex alignItems="center" gap={2}>
                                        <Text fontWeight="bold" fontSize={'14px'}>Deferred deep link</Text>
                                        <Tooltip
                                            borderRadius={5}
                                            label={
                                                <Box fontSize="sm" p="5px">
                                                    <Text fontWeight={'bold'}>Using a deferred deep link</Text><br></br>
                                                    <Text mb={2}>A deferred deep link is a URL that sends people to your app in the respective app store. Once people install your app, the link will take them to a specific screen, such as a product page.</Text>
                                                    <Text mb={2}>To use a deferred deep link, you need to first connect the Facebook SDK. You can use any of these link types:</Text>
                                                    <Box>
                                                        <Text>* Android app link</Text>
                                                        <Text>* Custom URL scheme</Text>
                                                        <Text>* Facebook app link</Text>
                                                    </Box>
                                                </Box>
                                            }
                                            fontSize="md"
                                        >
                                            <InfoOutlineIcon pointerEvents="all" />
                                        </Tooltip>
                                    </Flex>
                                    <Input
                                        name="adcreative.asset_feed_spec.deeplink_url"
                                        placeholder="Enter a deferred deep link URL"
                                        size='sm'
                                        borderRadius="md"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.adcreative.asset_feed_spec.deeplink_url}
                                    />
                                </Flex>

                                <Flex direction="column" gap={1}>
                                    <Flex alignItems="center" gap={2}>
                                        <Text fontWeight="bold" fontSize={'14px'}>Custom store listing</Text>
                                        <Tooltip
                                            borderRadius={5}
                                            label={
                                                <Box fontSize="sm" p="5px">
                                                    <Text fontWeight={'bold'}>Using a custom store listing</Text><br></br>
                                                    <Text mb={2}>A custom store listing ID sends people who click your ad to a landing page that you've customised in the Google Play Store.</Text>
                                                    <Text mb={2}>Use this feature to create multiple custom product pages with different media and text that speak to your various audiences.</Text>
                                                </Box>
                                            }
                                            fontSize="md"
                                        >
                                            <InfoOutlineIcon pointerEvents="all" />
                                        </Tooltip>
                                    </Flex>
                                    <Input
                                        name="adcreative.asset_feed_spec.app_product_page_id"
                                        placeholder="Enter custom store listing ID"
                                        size='sm'
                                        borderRadius="md"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik?.values?.adcreative?.asset_feed_spec?.app_product_page_id}
                                    />
                                </Flex>
                            </>
                        ) : adset?.destination_type === 'APP' && ["OUTCOME_SALES", "OUTCOME_LEADS"].includes(campaign?.objective) ? (
                            <>
                                <Flex direction="column" gap={1}>
                                    <Flex alignItems="center" gap={2}>
                                        <Text fontWeight="bold" fontSize={'14px'}>Deep link</Text>
                                        <Text as="span" fontWeight="bold" color={'gray.600'}>Optional</Text>
                                        <Tooltip
                                            borderRadius={5}
                                            label={
                                                <Box fontSize="sm" p="5px">
                                                    <Text>Send people to a specific place in your app. You can use an Apple universal link, Android App Link, custom URL scheme or Facebook App Link.</Text>
                                                </Box>
                                            }
                                            fontSize="md"
                                        >
                                            <InfoOutlineIcon pointerEvents="all" />
                                        </Tooltip>
                                    </Flex>
                                    <Input
                                        name="adcreative.asset_feed_spec.website_url"
                                        placeholder="Enter the deep link URL"
                                        size='sm'
                                        borderRadius="md"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.adcreative.asset_feed_spec.website_url}
                                    />
                                </Flex>
                            </>
                        ) : null}

                        {['WHATSAPP'].includes(adset?.destination_type) ? (
                            <>
                                <Flex>
                                    <Text fontWeight={'bold'}>Message template</Text>
                                </Flex>
                            
                                {(() => {
                                const welcomeData = formik?.values?.adcreative?.page_welcome_message;

                                const type = welcomeData?.text_format?.customer_action_type;

                                const greeting = welcomeData?.text_format?.message?.text || '';
                                const autofillMessage = welcomeData?.text_format?.message?.autofill_message?.content || '';
                                const iceBreakers = welcomeData?.text_format?.message?.ice_breakers || [];

                                return (
                                    <Box>
                                        <Box border={'1px solid'} borderColor={'gray.200'} p={2} borderRadius={'md'} bg={backgroundColor}>
                                            <Text fontSize={'14px'}><strong>Greeting:</strong> {greeting}</Text>

                                            {type === 'autofill_message' && (
                                                <Text fontSize={'14px'}><strong>Pre-filled message:</strong> {autofillMessage}</Text>
                                            )}

                                            {type === 'ice_breakers' && (
                                                <>
                                                <Text fontSize={'14px'}><strong>Frequently asked questions</strong></Text>
                                                {iceBreakers.map((q, i) => (
                                                    <Text key={i} fontSize="14px">
                                                    {i + 1}. {q.title}
                                                    </Text>
                                                ))}
                                                </>
                                            )}
                                        </Box>

                                        <Button
                                            variant="outline"
                                            backgroundColor="transparent" 
                                            size={'sm'}
                                            leftIcon={<MdOutlineEdit />}
                                            mt={2}
                                            onClick={() => {
                                                onMessageModalOpen();
                                            }}
                                        >
                                            Edit
                                        </Button>
                                    </Box>
                                );
                                })()}
                            </>
                        ) : null}

                        {["OUTCOME_AWARENESS", "OUTCOME_TRAFFIC", "OUTCOME_ENGAGEMENT"].includes(campaign?.objective) &&  adset?.destination_type !== 'PHONE_CALL' ? 
                            <Flex direction="column" gap={1}>
                                <Text fontWeight="bold" >Display link</Text>
                                <Input
                                    name="adcreative.caption"
                                    placeholder="Enter the link that you want to show on your ad"
                                    bg="#fff"
                                    size='sm'
                                    borderRadius="md"
                                    value={formik.values.adcreative.caption}
                                    onChange={formik.handleChange}
                                />
                            </Flex>
                        : null}

                        {campaign?.objective === "OUTCOME_AWARENESS" || adset?.destination_type === 'ON_VIDEO'  ? 
                            <Flex direction={'column'} gap={1}>
                                <Flex alignItems="center" gap={2}>
                                    <Text fontWeight="bold" >Mobile app</Text>
                                    <Tooltip
                                        borderRadius={5}
                                        label={
                                            <Box fontSize="sm" p="5px">
                                                <Text>Only select a mobile app if you are using a universal link (iOS or Android app link).</Text>
                                            </Box>
                                        }
                                        fontSize="md"
                                    >
                                        <InfoOutlineIcon pointerEvents="all" />
                                    </Tooltip>
                                </Flex>
                                <Select
                                    name={`adcreative.app_id`}
                                    bg="#fff"
                                    size="sm"
                                    borderRadius="md"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik?.values?.adcreative?.app_id}
                                >
                                    <option value="">Choose app</option>
                                    {advertisableApps?.map((option) => (
                                    <option key={option.id} value={option.id}>
                                        {option.name}
                                    </option>
                                ))}
                                </Select>
                            </Flex>
                        :null}

                    </Flex>

                    {['APP', 'PHONE_CALL', 'ON_PAGE', 'WHATSAPP'].includes(adset?.destination_type) ? null :
                        <Flex direction={'column'} gap={2} borderRadius="md" bg={background} p={4} mb={4}>
                            <Text fontWeight={'bold'}>Tracking</Text>
                            <Flex direction="column" gap={1}>
                                <Flex alignItems={'center'}>
                                    <Text mb={2} fontWeight="bold">
                                        URL parameters{" "}
                                        {/* <Text as="span" fontWeight="bold" color={'gray.600'} mr={1}>.</Text> */}
                                        <Text as="span" fontWeight="bold" color={'gray.600'}>Optional</Text>
                                    </Text>
                                    <Tooltip
                                        borderRadius={5}
                                        label={
                                            <Box fontSize="sm" p={'5px'}>
                                                <Text >
                                                    Add parameters to the end of your website URL to track where your visitors are coming from.
                                                </Text>
                                            </Box>
                                        }
                                        fontSize="md"
                                    >
                                        <InfoOutlineIcon pointerEvents="all" ml={2} mb={2} />
                                    </Tooltip>
                                </Flex>
                                <Input
                                    name="adcreative.url_tags"
                                    placeholder="key1=value1&key2=value2"
                                    bg="#fff"
                                    size='sm'
                                    borderRadius="md"
                                    value={formik.values.adcreative.url_tags}
                                    onChange={formik.handleChange}
                                />
                                <Flex mt={2}>
                                    <Button onClick={() => {
                                        setUrlParamModalOpen(true)
                                    }}
                                        variant="link"
                                        color='brand'>
                                        <Text fontSize={'12px'} >{'Build a URL parameter'}</Text>
                                    </Button>
                                </Flex>
                                {formik.touched.adcreative?.url_tags && formik.errors.adcreative?.url_tags && (
                                    <Text fontSize={"12px"} color="red.500">{formik.errors.adcreative?.url_tags}</Text>
                                )}
                            </Flex>
                        </Flex>
                    }

                    <Flex direction={'column'} gap={2} borderRadius="md" bg={background} p={4} mb={4}>
                        <Flex direction="column" gap={1}>
                            <Text fontWeight="bold">CPA</Text>
                            <Input
                                name="cpa"
                                placeholder="Enter CPA"
                                size='sm'
                                borderRadius="md"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.cpa}
                            />
                        </Flex>
                    </Flex>

                    <Flex mb={2}>
                        <Button
                            size="sm"
                            colorScheme="brand"
                            isLoading={formik.isSubmitting}
                            type="submit"
                            isDisabled={!formik.isValid}
                        >
                            Save
                        </Button>
                    </Flex>
                </Flex>

                <Flex flex={0.6} px={4} direction={'column'} justifyContent={'space-between'} borderRadius={'md'} boxShadow="0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08)">
                    <Flex py={2} gap={2} direction={'column'}>
                        <Flex py={2} gap={2}>
                            <Switch isChecked={isEnabled} colorScheme='brand' onChange={() => setIsEnabled(prevState => !prevState)} />
                            <Text fontWeight={'bold'} fontSize={'14px'}>Ad preview  </Text>
                        </Flex>
                        <Divider />
                        {isEnabled &&
                            <PublishSizeAdPreviews placements={targeting} file={formik?.values} adsAccountData={adsAccount} />
                        }
                    </Flex>

                    <Flex my={2} alignItems={'center'}>
                        <Text fontSize={'12px'} mr={2}>Ad rendering and interaction may vary based on device, format and other factors.</Text>
                        <Tooltip
                            borderRadius={5}
                            label={
                                <Box fontSize="12px" p="5px">
                                    <Text>
                                        Ads Manager previews are just examples and are not a substitute for reviewing Help Centre guidance and testing formats and devices to ensure that your ad delivers as intended.
                                    </Text>
                                </Box>
                            }
                            fontSize="md"
                        >
                            <InfoOutlineIcon pointerEvents="all" boxSize={3} />
                        </Tooltip>
                    </Flex>
                </Flex>
            </Flex>

            <Modal isOpen={isUrlModalOpen} onClose={() => setUrlModalOpen(false)} scrollBehavior={"inside"}
                size={"2xl"}
                isCentered={true}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader css={{ boxShadow: '0 0px 5px rgba(0, 0, 0, 0.1)' }}>Build a URL parameter</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <BuildUrlParamsUpdate 
                        link={{
                            link: formik.values?.adcreative?.asset_feed_spec?.website_url
                        }} 
                        onClose={() => setUrlModalOpen(false)} onUrlChange={handleUrlChange} 
                        />
                    </ModalBody>
                </ModalContent>
            </Modal>

            <Modal isOpen={isUrlParamModalOpen} onClose={() => setUrlParamModalOpen(false)} scrollBehavior={"inside"}
                size={"2xl"}
                isCentered={true}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader css={{ boxShadow: '0 0px 5px rgba(0, 0, 0, 0.1)' }}>Build a URL parameter</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <UrlParametersUpdate 
                            link={{
                                url_tags: formik.values?.adcreative?.url_tags
                            }} 
                            onClose={() => setUrlParamModalOpen(false)}
                            onUrlChange={handleUrlParamChange} 
                        />
                    </ModalBody>
                </ModalContent>
            </Modal>

            <Modal isOpen={isEditMediaOpen} onClose={OnEditMediaClose} scrollBehavior={"inside"} size={"5xl"} isCentered={true}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Select media for placements</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Flex gap={2} justifyContent={'center'}>
                            {selectedMediaUrls
                                ?.sort((a, b) => {
                                    const order = ['square', 'vertical', 'horizontal'];
                                    return order.indexOf(a.placement) - order.indexOf(b.placement);
                                })
                                .map(({ placement, url, source, mediaType }) => {
                                    // Filter logic
                                    const shouldSkip =
                                        adset?.destination_type === 'APP' &&
                                        campaign?.objective === 'OUTCOME_SALES' &&
                                        placement !== 'square' &&
                                        placement !== 'vertical';

                                    if (shouldSkip) return null;
                                
                                    return(
                                        <Box
                                            key={`${placement}`}
                                            border="1px solid"
                                            borderColor={'gray.100'}
                                            borderRadius="md"
                                            p={2}
                                            width={'240px'}
                                            height={
                                            placement === 'square'
                                                ? '300px'
                                                : placement === 'vertical'
                                                ? '530px'
                                                : '230px'
                                            }
                                            display="flex"
                                            flexDirection="column"
                                            gap={2}
                                        >
                                            <Text fontWeight="bold" textTransform="capitalize">
                                            {placement}
                                            </Text>
                                            {source ? (
                                                <Box
                                                width="220px"
                                                height={
                                                    placement === 'square'
                                                    ? '200px'
                                                    : placement === 'vertical'
                                                        ? '440px'
                                                        : '120px'
                                                }
                                                display="flex"
                                                alignItems="center"
                                                justifyContent="center"
                                                bg="gray.200"
                                                borderRadius="md"
                                                >
                                                <Box
                                                    as="video"
                                                    controls
                                                    src={source}
                                                    maxWidth="100%"
                                                    maxHeight="100%"
                                                    style={{ objectFit: 'contain', objectPosition: 'center' }}
                                                />
                                            </Box>
                                            ) : (
                                            <Box
                                                width="220px"
                                                height={
                                                placement === 'square'
                                                    ? '200px'
                                                    : placement === 'vertical'
                                                    ? '430px'
                                                    : '120px'
                                                }
                                                display="flex"
                                                alignItems="center"
                                                justifyContent="center"
                                                bg="gray.200"               
                                                borderRadius="md"
                                            >
                                                <Image
                                                src={url}
                                                alt={placement}
                                                maxWidth="100%"
                                                maxHeight="100%"
                                                objectFit="contain"      
                                                objectPosition="center"  
                                                />
                                            </Box>
                                            )}
                                            <Flex>
                                            <Button
                                                size="sm"
                                                variant={'solid'}
                                                colorScheme={'gray'}
                                                mt={2}
                                                leftIcon={<FaExchangeAlt />}
                                                onClick={() => handleReplaceImage(placement, mediaType)}
                                            >
                                                Replace
                                            </Button>
                                            </Flex>
                                        </Box>
                                    )
                                })}
                        </Flex>
                    </ModalBody>
                    <ModalFooter gap={2}>
                        <Button 
                            colorScheme="gray"
                            variant="solid"
                            size={'sm'} 
                            onClick={OnEditMediaClose}
                            >
                            Cancel
                        </Button>
                        <Button colorScheme="brand" size={'sm'} onClick={OnEditMediaClose}>
                            Save
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            <MessageTemplateModal
                isOpen={isMessageModalOpen}
                onClose={onMessageModalClose}
                accountId={''}
                welcomeData={formik.values?.adcreative?.page_welcome_message}
                onSave={(updatedData) => {
                    formik.setFieldValue('adcreative.page_welcome_message', updatedData);
                    onMessageModalClose();
                }}
            />

            <ReplaceDriveModal
                isDriveModalOpen={isReplaceModalOpen}
                selectedAdAccounts={[{
                    id: adsAccount._id,
                    adsAccountId: adsAccount.adsAccountId,
                    adsAccountName: adsAccount.adsAccountName,
                }]}
                onClose={() => {
                    OnReplaceModalClose();
                }}
                onSubmit={handleImageSelectedFromReplaceDrive}
                uploadPurpose="update"
                mediaType={formik?.values?.adcreative?.asset_feed_spec?.ad_formats === 'SINGLE_VIDEO' ? 'video' : 'image'}
            />
        </form>
    );
};

export default SizePublishAdupdate;
